import React from "react";
import HeroSection from "../containers/WebServices/HeroSection";
import Section_one from "../containers/WebServices/Section_one";
import Technology from "../containers/WebServices/Technology";
import ChooseUs from "../containers/WebServices/WhyChooseUs";
import Portfolio from "../containers/WebServices/Portfolio";

const WebsiteDevelopment = () => {
  return (
    <>
      <HeroSection />
      <Section_one/>
      <Portfolio/>
      <Technology/>
      <ChooseUs/>
    </>
  );
};

export default WebsiteDevelopment;
